<template v-slot:default="{ isActive }">
    <v-dialog
      v-model="dialog"
      width="60rem"
      class="layer-popup"
      scrollable
    >
      <v-card>
        <!--content-->
        <v-card-title class="d-flex justify-space-between align-center">
          <div class="pop-title">{{t('message.viewDetails')}}</div>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click.stop="dialog = false"
          ></v-btn>
        </v-card-title>
        <!--content-->
        <v-card-text class="ty01" @click.stop="">
          <div class="tab-group ty01 ty01-01">
            <v-tabs
              v-model="tab"
            >
              <v-tab value="tabCont1" v-if="storeRef.popupType.value != '3'">{{t('message.monitoring')}}</v-tab>
              <v-tab value="tabCont2">{{t('message.safetyTalk')}}</v-tab>
            </v-tabs>
          </div>
          <div class="content-box bg-none">
            <div class="content-inner-box">
            <v-tabs-window v-model="tab">
              <v-tabs-window-item value="tabCont1">
                <div class="list-group2 ty01 ty01-01" @click.stop.prevent="onClickStop">
                  <!--list-->
                  <div class="list" v-for="(item, i) in monitoringItems" :key="i">
                    <div class="row1">
                      <div class="num">{{i+1}}</div>
                      <div class="txt">{{item.behaviorTitle}}</div>
                      <div class="right-area">
                        <div class="check-group ty01">
                          <v-checkbox :label="t('message.notApplicable')"
                                      :model-value="item.etcYn"
                                      @click.stop="item.etcYn=='Y'?'N':'Y'"
                                      true-value="Y" false-value="N" :readonly="true"></v-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="row2">
                      <div class="radio-group2">
                        <v-radio-group v-model="item.answerData">
                          <v-radio :label="t('message.safe')" value="1"></v-radio>
                          <v-radio :label="t('message.unsafe')" value="0"></v-radio>
                        </v-radio-group>
                      </div>
                      <div class="inner" v-if="item.answerData == 0">
                        <!--다중체크 스타일-->
                        <div class="check-group3" v-if="item.multiYn == 'Y'">
                          <v-checkbox v-for="(item2, i2 ) in item.behaviorComments"
                                      v-model="item.comments"
                                      :label="item2.commentTitle"
                                      :value="item2.idx">
                          </v-checkbox>
                        </div>
                        <div class="radio-group3" v-if="item.multiYn != 'Y'">
                          <v-radio-group v-model="item.commentIdx">
                            <v-radio v-for="(item2, i2 ) in item.behaviorComments"
                                     :key="i2"
                                     :label="item2.commentTitle"
                                     :value="item2.idx"
                                     :disabled="item.etcYn=='Y'">
                            </v-radio>
                          </v-radio-group>
                        </div>
                        <c-input :placeholder="item.commentIdx==0?item.comment:''" :disabled="true"></c-input>
                      </div>
                    </div>
                  </div>
                  <!--list-->
                </div>
              </v-tabs-window-item>
              <v-tabs-window-item value="tabCont2">
                <div class="nodata-group" v-if="timelineItems?.length == 0">
                  <div class="txt">{{t('message.noRegisteredData')}}</div>
                </div>
                <div class="dropdown-group2 ty01 mo-ty01">
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel v-for="(item, i) in timelineItems" :key="i">
                      <v-expansion-panel-title>{{t('message.safetyTalk')}}{{i+1}}</v-expansion-panel-title>
                      <v-expansion-panel-text>
                        <div class="form-group col-ty">
                          <div class="tit-group">
                            <div class="tit02">{{t('message.basicInfo')}}</div>
                          </div>
                          <!--form-row-->
                          <div class="form-row">
                            <div class="txt-tit">{{t('message.type')}}</div>
                            <div class="row">
                              <c-Input v-model="item.typeText" :name="item.typeText" :disabled="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row" v-if="item.type=='1'">
                            <div class="txt-tit">{{t('message.correctiveActionRequired')}}</div>
                            <div class="row">
                              <c-Input v-model="item.actionYnText" :name="item.actionYnText" :disabled="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row" v-if="item.actionYn=='Y' || item.type=='2'">
                            <div class="txt-tit">{{t('message.targetPerson')}}</div>
                            <div class="row">
                              <c-Input v-model="item.targetText" :name="item.targetText" :disabled="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row" v-if="item.actionYn=='Y'">
                            <div class="txt-tit">{{t('message.actionDeadline')}}</div>
                            <div class="row">
                              <c-Input v-model="item.goalDate" :name="item.goalDate" :disabled="true"/>
                            </div>
                          </div>

                        </div>
                        <div class="form-group col-ty line-ty">
                          <div class="tit-group">
                            <div class="tit02">{{t('message.detailedInfo')}}</div>
                          </div>
                          <!--form-row-->
                          <div class="form-row" v-if="item.type=='1'">
                            <div class="txt-tit">{{t('message.monitoringBehavior')}}</div>
                            <div class="row">
                              <c-Input v-model="item.behaviorTitle" :name="item.behaviorTitle" :disabled="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row" v-if="item.type=='1'">
                            <div class="txt-tit">{{t('message.location')}}</div>
                            <div class="row">
                              <c-Input v-model="item.place" :name="item.place" :disabled="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row ty07">
                            <div class="txt-tit">{{item.type=='1'?t('message.specificSituation'):t('message.praiseReason')}}</div>
                            <div class="row">
                              <Textarea v-model="item.situation" :name="item.situation" :readonly="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row ty07" v-if="item.type=='1'">
                            <div class="txt-tit">{{t('message.cause')}}</div>
                            <div class="row">
                              <Textarea v-model="item.cause" :name="item.cause" :readonly="true"/>
                            </div>
                          </div>
                          <!--form-row-->
                          <div class="form-row ty07" v-if="item.type=='1'">
                            <div class="txt-tit">{{t('message.correctiveActionDetails')}}</div>
                            <div class="row">
                              <Textarea v-model="item.action" :name="item.action" :readonly="true"/>
                            </div>
                          </div>

                          <div class="img-slider02">
                            <v-carousel
                            >
                              <div class="img-wrap">
                              <v-carousel-item
                                v-for="(item2,i2) in item.timelineImages"
                                :key="i2"
                                :src="utils.getBaseUrl('timeline', item2.filePath)"
                                cover
                                @click="onClickPreview(item2)"
                              ></v-carousel-item>
                              </div>
                            </v-carousel>
                          </div>
                        </div>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-tabs-window-item>
            </v-tabs-window>
            </div>
          </div>
        </v-card-text>
        <!--버튼-->
        <v-card-actions class=" d-flex justify-end">
          <c-btn01 v-bind="btnConfirm" @click.stop="dialog = false"/>
        </v-card-actions>
      </v-card>
      <DialogImgView v-model="previewDialogModel" @close="previewDialogModel=false" :src="previewSrc"/>
      <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
    </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import _ from 'lodash';
import dayjs from "dayjs";
import TimelineService from "@/services/timeline.service";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const dialog = defineModel()

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)

//bind
const snackbar = ref(false)
const snackText = ref('')
const tab = ref('tabCont1')
const previewDialogModel = ref(false)
const panel = ref([0])
const monitoringInfo:any = ref({})
const monitoringItems:any = ref([])
const timelineItems:any = ref([])
const previewSrc = ref('')
/*
const typeModel = ref('')
const actionYnModel = ref('')
const targetTypeModel = ref('')
const goalDateModel = ref('')
const behaviorModel = ref('')
const placeModel = ref('')
const situationModel = ref('')
const causeModel = ref('')
const actionModel = ref('')
 */

const items:any = [
  {
    src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
  },
  {
    src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
  },
  {
    src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg',
  },
  {
    src: 'https://cdn.vuetifyjs.com/images/carousel/planet-.jpg',
  },
]

//ui
const btnConfirm = {
  btnText: t('message.confirm'),
}

//hook
onUpdated(() => {
  const popupIdx = storeRef.popupIdx.value
  const viewIdx = storeRef.viewIdx.value
  const popupType = storeRef.popupType.value
  if(popupType == '1')
    tab.value = 'tabCont1'
  else
    tab.value = 'tabCont2'
  if(viewIdx && dialog.value) {
    //관찰, 타임라인 같이 노출하는 케이스
    if (popupType == '1' || popupType == '2') {
      let params = {
        answerIdx: popupIdx,
        idx: viewIdx, //bbs idx
        isTemp: 'N'
      }

      BbsService.getBbsMonitoring(params).then(
        (response) => {
          //모니터링
          monitoringInfo.value = response.result

          //행동
          monitoringItems.value = response.result.monitoringBehaviors

          //코멘트 답변셋팅
          const answerItems = response.result.monitoringAnswers[0].answers
          _.forEach(monitoringItems.value, function (behaviorItem, key) {
            const answer = _.find(answerItems, {behaviorIdx: behaviorItem.idx})
            if (answer) {
              behaviorItem.etcYn = answer.etcYn
              if(behaviorItem.etcYn == 'Y'){
                behaviorItem.answerData2 = null
                behaviorItem.answerData = null
              }
              else{
                behaviorItem.answerData2 = answer.answerData2
                behaviorItem.answerData = answer.answerData
              }
              //코멘트 셋팅
              if(behaviorItem.multiYn == 'Y'){
                const commentTitles = answer.comment?.split(',') || []
                const commentIdxs = answer.commentIdx?.split(',') || []
                const mergedComments = []
                commentIdxs.forEach((idxStr, i) => {
                  const idx = Number(idxStr)
                  const title = commentTitles[i] || ''
                  if (idx === 0) {
                    behaviorItem.comment = title;
                    behaviorItem.commentIdx = 0;
                  } else {
                    mergedComments.push(idx)
                  }
                })
                behaviorItem.comments = mergedComments
              }
              else {
                behaviorItem.comment = answer.comment
                behaviorItem.commentIdx = Number(answer.commentIdx)
              }
            }
          })

          //임시저장
          _.forEach(monitoringItems.value, function (val, key) {
            _.forEach(monitoringInfo.value.monitoringAnswers, function (val2, key2) {
              _.forEach(val2.answers, function (val3, key3) {
                if (val3.behaviorIdx == val.idx) {
                  //아카이브 데이터들은 100점이라 임시로 1로치환
                  if(val3.answerData == 100)
                    val.answerData = '1'
                  else if(val3.etcYn != 'Y') {
                    if (val3.answerData == '')
                      val.answerData = '0'
                    else
                      val.answerData = val3.answerData
                  }
                }
              })
            })
          })

          //타임라인
          if (response.result.monitoringTimelines.length > 0) {
            timelineItems.value = response.result.monitoringTimelines
            _.forEach(timelineItems.value, function (val, key) {
              val.typeText = val.type == '1' ? t('message.correctiveSafetyTalk') : t('message.supportiveSafetyTalk')
              val.actionYnText = val.actionYn == 'Y' ? t('message.necessary') : t('message.notNecessary')
              val.targetText = t('message.none')
              if (val.targetType == '2') val.target = val.targetDept
              else if (val.targetType == '3') val.target = val.targetMember
              val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(val.goalDate).format('YYYY-MM-DD')
            })
          }
          else {
            timelineItems.value = []
          }
        },
        (error) => {
          if (error.status == 403)
            utils.movePage('/login')
          else {
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
    }
    //타임라인만 노출하는 케이스
    else if(popupType == '3'){
      timelineItems.value = []
      TimelineService.getTimelineList({idx:popupIdx}).then(
        (response) => {
          //타임라인
          timelineItems.value = response.result
          _.forEach(timelineItems.value, function (val, key) {
            val.typeText = val.type == '1' ? t('message.correctiveSafetyTalk') : t('message.supportiveSafetyTalk')
            val.actionYnText = val.actionYn == 'Y' ? t('message.necessary') : t('message.notNecessary')
            val.targetText = t('message.none')
            if (val.targetType == '2') val.target = val.targetDept
            else if (val.targetType == '3') val.target = val.targetMember
            val.goalDate = dayjs(val.goalDate).format('YYYY-MM-DD') == 'Invalid Date' ? '' : dayjs(val.goalDate).format('YYYY-MM-DD')
          })
        },
        (error) => {
          if(error.status == 403)
            utils.movePage('/login')
          else{
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
    }
  }
})

function onClickPreview(item){
  previewSrc.value = utils.getBaseUrl('timeline', item.filePath)
  previewDialogModel.value=true
}

function onClickStop(){
  utils.log('onClickStop')
}
</script>


<style lang="scss">
</style>
